module.exports = __webpack_public_path__ + "media/img/event/pdp_header-1fc98831c194f221a98ed572aaee6060.png";